const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#25d366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.67 6.3a8 8 0 0 0-12.54 9.61L4 20l4.22-1.11a7.93 7.93 0 0 0 3.81 1A8 8 0 0 0 17.67 6.3zM12 18.55a6.54 6.54 0 0 1-3.37-.92l-.24-.14-2.51.66.67-2.45-.16-.25a6.63 6.63 0 0 1 10.3-8.2 6.52 6.52 0 0 1 1.93 4.68A6.63 6.63 0 0 1 12 18.55zm3.64-5c-.2-.1-1.18-.59-1.36-.65s-.32-.1-.45.1-.52.65-.63.78a.31.31 0 0 1-.43.05 5.41 5.41 0 0 1-1.6-1 5.67 5.67 0 0 1-1.11-1.38c-.12-.2 0-.31.09-.41s.19-.23.29-.34a1.17 1.17 0 0 0 .2-.34.34.34 0 0 0 0-.34C10.61 10 10.21 9 10 8.6s-.32-.34-.45-.34h-.34a.73.73 0 0 0-.53.25A2.24 2.24 0 0 0 8 10.16a3.9 3.9 0 0 0 .81 2.06 8.86 8.86 0 0 0 3.4 3 9.58 9.58 0 0 0 1.13.42 2.79 2.79 0 0 0 1.26.08 2.06 2.06 0 0 0 1.34-1 1.62 1.62 0 0 0 .12-.94c-.06-.03-.2-.08-.39-.18z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    "data-name": "WA Logo"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.ba6c2c04042846084b1cad55720d59c8.svg";
export { ForwardRef as ReactComponent };